query FootballTeamByTeamId (
  $teamId: UUID!
){
  team: footballTeamByTeamId(teamId: $teamId) {
    squad
    teamId
    playerMappedForProjections: footballTeamPlayerProjectionsMappedsByTeamId {
      nodes {
        playerId
      }
    }
  }
}
